import React, { useEffect, useState, useCallback } from 'react'
import { connect } from 'react-redux'
import {
    BrowserRouter,
    Route,
    Switch,
    useHistory,
    withRouter,
} from 'react-router-dom'
import { MathJaxContext } from 'better-react-mathjax'
import Header from '../src/components/Header/Header'
import SubmitPage from '../src/components/SubmitPage/SubmitPage'
import {
    UPDATE_DEVICE_ID,
    UPDATE_PUSH_NOTIFICATION_EVENT,
} from '../src/constants/actionTypes'
import InstructionsPage from '../src/views/InstructionsPage/InstructionsPage'
import TestAnalytics from '../src/views/TestAnalytics/TestAnalytics'
import TestPanel from '../src/views/TestPanel/TestPanel'
import Thankyou from '../src/views/Thankyou/Thankyou'
import './App.css'
import InternetIssues from './components/InternetIssue/InternetIssue'
import Results from './views/Results/Results'
import { isInPhoneOrTablet } from './utils/common/isInPhoneOrTablet'
import { MATHJAX_2_CONFIG } from 'constants/mathjaxConfig'

const mapStateToProps = (state) => ({
    active_section: state.active_section,
    header_visible: state.header_visible,
    instructions: state.instructions,
    packageId: state.packageId,
    get_ip_address: state.get_ip_address,
    queryparam: state.queryparam,
    persistor: state.persistor,
    testStatus: state.teststatus,
})

const mapDispatchToProps = (dispatch) => ({
    setDeviceId: (payload) => dispatch({ type: UPDATE_DEVICE_ID, payload }),
    setPushNotificationEvent: (payload) =>
        dispatch({ type: UPDATE_PUSH_NOTIFICATION_EVENT, payload }),
})

const App = (props) => {
    const [isHeaderVisible, setIsHeaderVisible] = useState(true)
    const [active, setActive] = useState(props.active_section)
    const history = useHistory()

    const isPreview =
        sessionStorage.getItem('tp_preview_token') &&
        sessionStorage.getItem('test_id')
            ? true
            : false
    const mathjaxStartupHandler = useCallback((mathJax) => {
        mathJax.Hub.processSectionDelay = 0
        mathJax.Hub.processUpdateDelay = 0
        function retryTypeset(errorStr, message) {
            console.error(errorStr, message, message[1], message[2])
            window.MathJax?.Hub?.Queue(() => window.MathJax.Hub.Typeset())
        }
        function mathErrorHandler(message) {
            retryTypeset('mathjax_error - Math Processing Error', message)
        }
        function texErrorHandler(message) {
            retryTypeset('mathjax_error - TeX Jax - parse error', message)
        }
        // Docs: https://docs.mathjax.org/en/v2.7-latest/advanced/debugging-tips.html
        window.MathJax?.Hub?.Register.MessageHook(
            'Math Processing Error',
            mathErrorHandler,
        )
        window.MathJax?.Hub?.Register.MessageHook(
            'TeX Jax - parse error',
            texErrorHandler,
        )
    }, [])

    useEffect(() => {
        if (
            props.location.pathname !== '/success' &&
            props.location.pathname !== '/testpanel' &&
            props.location.pathname !== '/' &&
            window.location.href.slice(window.location.href.length - 8) !==
                '/success' &&
            window.location.href.slice(window.location.href.length - 8) !==
                '/results' &&
            props.header_visible &&
            Object.keys(props.instructions).length
        ) {
            setIsHeaderVisible(false)
        } else if (!isHeaderVisible) {
            setIsHeaderVisible(true)
        }
    }, [window.location.href])

    // Removed setPushNotification state update, its not being used anywhere

    return (
        <BrowserRouter>
            <MathJaxContext
                config={MATHJAX_2_CONFIG}
                version={2}
                hideUntilTypeset="first"
                // to handle flicker
                onStartup={mathjaxStartupHandler}
                onError={(error) => {
                    console.error('error while rendering mathjax content:', error)
                }}
            >
                <div className="App" id="test_player">
                    {props.header_visible ? (
                        <Header
                            isPreview={isPreview}
                            style={
                                props.location.pathname === '/submit' &&
                                isInPhoneOrTablet()
                                    ? { height: '90px' }
                                    : null
                            }
                        />
                    ) : null}
                    <Switch>
                        <Route
                            exact
                            path="/"
                            render={() => <InstructionsPage />}
                        />
                        <Route
                            path="/testpanel"
                            render={(props) => (
                                <TestPanel active={active} setActive={setActive} />
                            )}
                        />
                        <Route
                            path="/submit"
                            render={(props) => (
                                <SubmitPage persistor={props.persistor} />
                            )}
                        />
                        <Route
                            path="/success"
                            render={(props) => <Thankyou isPreview={isPreview} />}
                        />
                        <Route
                            path="/analytics"
                            component={(props) => (
                                <TestAnalytics setActive={setActive} {...props} />
                            )}
                        />
                        <Route
                            path="/results"
                            render={(props) => <Results />}
                        />
                        <Route path="/offline" component={InternetIssues} />
                    </Switch>
                </div>
            </MathJaxContext>
        </BrowserRouter>
    )
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))
